<template>

<button :class="cssClass" v-on:click="navigateToNextStep()">{{label}}</button>

</template>

<script>

export default {
  props: ['label', 'overrideClass'],
  computed: {
    cssClass() {
      if (this.overrideClass !== null && this.overrideClass !== undefined && this.overrideClass !== '') {
        return this.overrideClass;
      }

        return 'cta_btn _purple _fullwidth mb40';
    }
  },
  methods: {
    navigateToNextStep() {
      this.$router.app.$emit('navigateToNextStep');
    }
  }
};
</script>
